import { Component, OnInit } from '@angular/core';
import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';
import { BsModalService } from '../../../../node_modules/ngx-bootstrap';
import { SessionService } from '../../services/session2.service';
import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { AdminOpsInternalService } from '../../services/admin/admin-ops-internal.service';
import { AdminGoldensetResultService } from '../../services/admin/admin-goldenset-result.service';
import { GlobalMessageService } from '../../services/global-message.service';
import { ErrorService } from '../../services/error.service';

@Component({
  selector: 'admin-goldenset',
  templateUrl: './admin-goldenset.component.html'
})
export class AdminGoldensetComponent implements OnInit {
  loadingPage: boolean = true;
  resultSummary = [];

  constructor(
    private modalService: BsModalService,
    private cacheService: CacheService,
    private sessionService: SessionService,
    private adminOpsInternalService: AdminOpsInternalService,
    private globalMessageService: GlobalMessageService,
    private errorService: ErrorService,
    private adminGoldsetResultService: AdminGoldensetResultService
  ) { }

  ngOnInit() {
    if (!this.cacheService.get('session')) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.initView();
        }
      );
    }
    else {
      this.initView();
    }
  }


  private initView() {
    this.loadingPage = true;
    this.adminGoldsetResultService.getList()
      .subscribe(
        (result: any) => {
          this.loadingPage = false;
          this.resultSummary = result;

        },
        error => {

          this.globalMessageService.error('Failed to re-run data.');
          this.errorService.log(error, 'admin-goldenset.component', 'getList');
        }
      );

  }

  getSummaryKeys(result) {
    return Object.keys(result.summary);
  }

  reprocessData() {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Are you sure? The demo account will be empty for a few minutes.`,
        confirm: function () {

          me.adminOpsInternalService.reprocessData().subscribe();
        }
      }
    }));
  }

  loadIncorrect(item) {
    this.adminGoldsetResultService.getIncorrect(item.runId)
      .subscribe(
        (result: any) => {
          item.incorrect = result
        },
        error => {
          this.globalMessageService.error('Failed to re-run data.');
          this.errorService.log(error, 'admin-goldenset.component', 'getList');
        }
      );
  }

}



// WEBPACK FOOTER //
// ./client/app/admin/admin-goldenset/admin-goldenset.component.ts